import React from 'react';

const Mark = ({ size = 38 }) => (
  <span style={{ display: 'inline-flex', width: size, height: size, filter: 'drop-shadow(0 6px 10px rgba(150,60,30,0.25))' }} aria-hidden="true">
    <svg viewBox="0 0 40 40" width={size} height={size}>
      <rect x="1" y="1" width="38" height="38" rx="11" fill="var(--brick)" />
      <circle cx="20" cy="15" r="6" fill="#fff" opacity="0.95" />
      <rect x="9" y="22" width="22" height="9" rx="4.5" fill="#fff" opacity="0.95" />
    </svg>
  </span>
);

export default Mark;
